module.exports = __webpack_public_path__ + "img/violet_064.6854e69a.png";